import Vue from 'vue';
import { Validatable, VGrid } from '@/types/Components';
import api from '@/services/Api';

const GridEdit = Vue.extend({
    data: () => ({
        gridEditStatus: false,
        gridEditStatusText: '',
        gridEditStatusColor: 'success',
        gridEditStatusTimeout: 2500,
        gridEditLoading: false,
        gridEditValue: null,
    }),
    methods: {
        onSaveEdit(property: string, item: Record<string, unknown>): void {
            const refs = this.$refs as {
                grid: VGrid<unknown>;
                [key: string]: Vue | Validatable;
            };

            // TODO: Eigene v-edit-dialog Komponente für Validierung
            if (refs[property] && !(refs[property] as Validatable).validate()) {
                return;
            }

            item[property] = this.gridEditValue;

            this.gridEditLoading = true;

            const grid = refs.grid;

            type ExtStoreResponse = { body: { data: unknown | null, message: string, success: boolean } };

            api.post<ExtStoreResponse>(grid.config.remote + '/save', item)
                .then((response) => {
                    if (response.data.body.success) {
                        this.gridEditStatusText = response.data.body.message;
                        this.gridEditStatusColor = 'success';
                        grid.load();
                    } else {
                        this.gridEditStatusText = response.data.body.message;
                        this.gridEditStatusColor = 'error';
                    }
                })
                .catch((error) => {
                    console.error(error);
                    this.gridEditStatusText = 'Fehler beim Speichern';
                    this.gridEditStatusColor = 'error';
                })
                .finally(() => {
                    this.gridEditLoading = false;
                    this.gridEditStatus = true;
                });
        },
    }
});

export default GridEdit;
